export default __webpack_public_path__ + "img/1a58609f89a097f8cb83120e0d993c1b.svg";